import { render, staticRenderFns } from "./BTablePermissionGroups.vue?vue&type=template&id=6afe15c6&"
import script from "./BTablePermissionGroups.vue?vue&type=script&lang=js&"
export * from "./BTablePermissionGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports